var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"badge",attrs:{"href":"/ueber-uns.html","title":"Zertifizierung"}},[_c('img',{attrs:{"src":require("@/assets/images/zertifiziert.svg"),"width":"153","height":"157","alt":"25 Jahre Zertifiziert"}})])
}]

export { render, staticRenderFns }